/* eslint-disable react/no-danger */
import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { Button } from "../../Button";
import * as styles from "./BrandCard.module.scss";

const BrandCard = ({ image, logo, header, content, link, className, style }) => (
	<Card className={cx(styles.brandCard, className)} style={style}>
		{header && <Card.Header className={cx(styles.heading)}>{header}</Card.Header>}
		<div className={cx(styles.imageContainer)}>
			{image && (
				<Card.Image
					className={cx(styles.imageCover)}
					src={!image.srcSet && image.src}
					source={image.srcSet && image}
					alt={image.alt}
					fluid={image.fluid}
					clickable={link}
				/>
			)}
			{logo && (
				<div className={cx(styles.imageLogo)}>
					<Card.Image src={logo.src} alt={logo.alt} />
				</div>
			)}
		</div>
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<div className={cx(styles.contentContainerInner)}>
				{content && (
					<div
						className={cx(styles.contentContainerText)}
						dangerouslySetInnerHTML={{ __html: content }}
					/>
				)}
				{link && (
					<Button to={link.to} className={cx(styles.link)}>
						{link.text}
					</Button>
				)}
			</div>
		</Card.BodyContainer>
	</Card>
);

BrandCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}).isRequired,
	logo: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}),
	header: string,
	content: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
};

BrandCard.defaultProps = {
	logo: null,
	link: null,
	header: null,
	content: null,
	className: "",
	style: {},
};

export default BrandCard;
export { BrandCard };
